export default __webpack_public_path__ + "static/media/wallpaper.de0e77cd.png";